import React from "react";
import LoginExpired from "./components/Global/login-expired";
import Loading from "./loading";
import Toast from "./components/toast";
import ModalGlobal from "./components/Global/modal";

const Global = () => {
   return (
      <React.Fragment>
         <LoginExpired />
         <Loading />
         <Toast />
         <ModalGlobal />
      </React.Fragment>
   )
}

export default Global;